import { Box, Flex, Text, Textarea } from "@chakra-ui/react";
import { scrollbarStyle } from "../../theme/scrollbarStyles";






const CustomTextarea = ({ value, onChange, placeholder, rows=5 }:{
    value: string;
    onChange: (v:string) => void;
    placeholder: string;
    rows?: number;
}) => {
    return <Box pos='relative'>
        <Textarea 
            _placeholder={{color: '#B0B7C3'}}
            color='#171C22'
            mb='4px'
            rows={rows}
            sx={scrollbarStyle}
            p='12px'
            resize='none'
            placeholder={placeholder}
            maxLength={1000}
            value={value}
            onChange={e => onChange(e.target.value)}
            border='1px solid #DCE2EA'
        />


        <Flex justifyContent='right'
            color='#7E8B9A'
            fontSize='sm'
            pos='absolute'
            bottom='12px'
            right='10px'
        >
            <Text>{value.length}/1000</Text>
        </Flex>
    </Box>
}


export default CustomTextarea;